import { Alert, Snackbar } from '@mui/material';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

function FeedbackAlert({ message, severity, open, handleClose }) {
  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
}

FeedbackAlert.propTypes = {
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  severity: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
};

FeedbackAlert.defaultProps = {
  severity: 'success',
};

export default FeedbackAlert;
